import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip } from 'recharts';
import PropTypes from 'prop-types';
import Tooltip from '../PercentageTooltip';
import { calculatePercentages } from '../utils';
import colors from '../../colors';

const HorizontalBarChart = ({
  data,
  height,
  color,
  className = '',
  style = {}
}) => {
  if (!data) return null;
  const finalData = calculatePercentages(data);
  return /*#__PURE__*/React.createElement("div", {
    className: `chart__horizontal-bar-chart-wrapper ${className}`
  }, finalData.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: item.label,
    className: "chart__horizontal-bar-chart",
    style: style
  }, /*#__PURE__*/React.createElement("span", {
    className: "_col:sm(4) _nogutter"
  }, /*#__PURE__*/React.createElement("b", {
    className: "_m:right(2)"
  }, index + 1, "."), item.label), /*#__PURE__*/React.createElement("div", {
    className: "_col:sm(7) _nogutter _m:right(2)"
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: height
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: Array.of(item),
    layout: "vertical",
    animationBegin: 0,
    animationDuration: 1000
  }, /*#__PURE__*/React.createElement(XAxis, {
    hide: true,
    dataKey: "total",
    type: "number"
  }), /*#__PURE__*/React.createElement(YAxis, {
    hide: true,
    type: "category"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: "value",
    background: {
      fill: colors['grey-700']
    },
    fill: color,
    layout: "vertical"
  }), /*#__PURE__*/React.createElement(RechartsTooltip, {
    content: /*#__PURE__*/React.createElement(Tooltip, null)
  })))), /*#__PURE__*/React.createElement("div", {
    className: "_col:sm(1) _nogutter"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: 'left'
    }
  }, item.value)))));
};

HorizontalBarChart.defaultProps = {
  height: 18,
  color: colors.primary
};
HorizontalBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default HorizontalBarChart;